/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_Files_LabelInputs */

const da_forside_example_files_label = /** @type {(inputs: Forside_Example_Files_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filer i eksempelprøven`)
};

/** @type {(inputs: Forside_Example_Files_LabelInputs) => LocalizedString} */
const en_forside_example_files_label = da_forside_example_files_label;

/**

* @param {Forside_Example_Files_LabelInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_files_label = /** @type {((inputs?: Forside_Example_Files_LabelInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_Files_LabelInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_files_label(inputs)
	return /** @type {LocalizedString} */ ("Filer i eksempelprøven")
});